<div class="grid service-logs">

    <!-- Columna de servicios, agrupados por instancia -->
    <div class="col-12 md:col-4 lg:col-3">
        <div class="surface-card border-round p-3 service-logs__list">
            <div class="flex align-items-center justify-content-between mb-2">
                <span class="font-bold">Servicios</span>
                <button pButton type="button" class="p-button-text p-button-sm" icon="pi pi-refresh"
                    pTooltip="Actualizar el listado" [disabled]="loadingCatalog" (click)="loadCatalog()"></button>
            </div>

            <small class="text-color-secondary" *ngIf="loadingCatalog">
                <i class="pi pi-spin pi-spinner mr-1"></i>Cargando…
            </small>

            <!-- el error se dice con todas las letras: un listado vacío se leería como "no pasa nada" -->
            <p-messages severity="warn" *ngIf="catalogError && !loadingCatalog">
                <ng-template pTemplate>{{ catalogError }}</ng-template>
            </p-messages>

            <small class="text-color-secondary" *ngIf="!loadingCatalog && !catalogError && instances.length === 0">
                No hay ningún fichero de log. Puede que los servicios aún no hayan arrancado con la
                configuración nueva, o que el directorio compartido no esté accesible.
            </small>

            <div *ngFor="let instance of instances" class="mb-3">
                <div class="text-color-secondary text-sm uppercase mb-1">{{ instance.instance }}</div>

                <div *ngFor="let service of instance.services"
                    class="service-logs__item"
                    [class.service-logs__item--selected]="selectedInstance === instance.instance && selectedService === service.name"
                    (click)="select(instance.instance, service)">
                    <span class="service-logs__dot" [ngClass]="'service-logs__dot--' + freshness(service)"
                        [pTooltip]="'Último escrito: ' + (service.lastWriteAtUtc | date:'dd/MM/yyyy HH:mm:ss')"></span>
                    <span class="service-logs__name">{{ displayName(service.name) }}</span>
                    <span class="text-color-secondary text-sm">{{ formatSize(service.sizeBytes) }}</span>
                </div>
            </div>
        </div>
    </div>

    <!-- Consola y ficheros -->
    <div class="col-12 md:col-8 lg:col-9">
        <div class="surface-card border-round p-3 service-logs__panel">

            <div *ngIf="!selectedService" class="text-color-secondary">
                Elige un servicio para ver su registro.
            </div>

            <ng-container *ngIf="selectedService">
                <!-- cabecera: qué servicio y en qué instancia. Va fuera de las pestañas porque
                     identifica lo que se está mirando en las dos. -->
                <div class="flex gap-2 flex-wrap align-items-center mb-2">
                    <span class="font-bold">{{ displayName(selectedService) }}</span>
                    <span class="text-color-secondary text-sm">{{ selectedInstance }}</span>
                </div>

                <!-- el sondeo en vivo mira this.tab, así que el cambio de pestaña tiene que seguir
                     pasando por setTab: si no, seguiría leyendo la cola estando en "Ficheros" -->
                <p-tabView styleClass="p-tabview-panels-no-padding service-logs__tabs"
                    [activeIndex]="tab === 'live' ? 0 : 1"
                    (onChange)="setTab($event.index === 0 ? 'live' : 'files')">

                    <p-tabPanel header="En vivo" leftIcon="pi pi-bolt">
                        <div class="flex gap-2 flex-wrap align-items-center mb-3">
                            <div class="input-field service-logs__level">
                                <p-dropdown [options]="levelOptions" optionLabel="name" optionValue="value"
                                    [(ngModel)]="levelFilter" showClear placeholder="Todos los niveles"
                                    appendTo="body"></p-dropdown>
                            </div>

                            <div class="input-field service-logs__text-filter">
                                <input pInputText type="text" [(ngModel)]="textFilter" placeholder="Filtrar texto…" />
                            </div>

                            <small class="text-color-secondary" *ngIf="!followTail">
                                <i class="pi pi-angle-down mr-1"></i>
                                <a class="cursor-pointer" (click)="goToEnd()">Ir al final</a>
                            </small>

                            <!-- empujado con ml-auto: los filtros a la izquierda y la acción al final -->
                            <div class="input-field ml-auto">
                                <button pButton type="button" class="p-button-text"
                                    [label]="paused ? 'Reanudar' : 'Pausar'"
                                    [icon]="paused ? 'pi pi-play' : 'pi pi-pause'"
                                    (click)="togglePause()"></button>
                            </div>
                        </div>

                        <p-messages severity="warn" *ngIf="tailError">
                            <ng-template pTemplate>{{ tailError }}</ng-template>
                        </p-messages>

                        <!-- el propio <pre> es el que desplaza, con alto acotado: no una p-table -->
                        <pre #console class="service-logs__console" (scroll)="onConsoleScroll()"><span
                            *ngFor="let line of visibleLines"
                            class="service-logs__line"
                            [ngClass]="'service-logs__line--' + line.level">{{ line.text }}
</span><span class="text-color-secondary" *ngIf="visibleLines.length === 0">Sin líneas que mostrar.</span></pre>
                    </p-tabPanel>

                    <p-tabPanel header="Ficheros" leftIcon="pi pi-file">
                        <p-table [value]="files" styleClass="p-datatable-sm">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th>Fichero</th>
                                    <th style="width:8rem">Tamaño</th>
                                    <th style="width:12rem">Última escritura</th>
                                    <th style="width:6rem"></th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-file>
                                <tr>
                                    <td>{{ file.fileName }}</td>
                                    <td>{{ formatSize(file.sizeBytes) }}</td>
                                    <td>{{ file.lastWriteAtUtc | date:'dd/MM/yyyy HH:mm:ss' }}</td>
                                    <td>
                                        <!-- sin permiso de descarga el botón no se pinta; el backend lo
                                             comprueba igualmente -->
                                        <button pButton type="button" class="p-button-text p-button-sm"
                                            icon="pi pi-download" *ngIf="canDownload"
                                            pTooltip="Descargar. Puede contener datos personales y queda registrado"
                                            (click)="download(file)"></button>
                                    </td>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="emptymessage">
                                <tr><td colspan="4" class="text-color-secondary">No hay ficheros para este servicio.</td></tr>
                            </ng-template>
                        </p-table>
                    </p-tabPanel>
                </p-tabView>
            </ng-container>
        </div>
    </div>
</div>
